'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var RussianYandex = function RussianYandex(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 24 24' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M13.92 4.771h-1.13c-1.68 0-2.883 1.525-2.883 4.31 0 2.665 1.28 4.105 3.11 4.105h.903V4.771zM7.526 9.334c0-4.002 2.215-6.484 5.34-6.484h2.858c.261 0 .426.144.426.404v18.544c0 .216-.123.352-.35.352h-1.556a.338.338 0 0 1-.324-.327v-6.716h-1.012L9.47 21.878c-.073.185-.227.272-.44.272H7.25c-.33 0-.504-.313-.331-.627l3.757-6.851c-2.03-.965-3.15-2.85-3.15-5.338z'
      })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = RussianYandex;